import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService, NationalityService } from 'app/services';
import { Salutation, Suffix, CompanyPosition, MerchantServiceTypeEnum } from 'app/models';
import { MartMerchantsComponent } from 'app/components/mart/mart-merchants/mart-merchants.component';

enum menuTab {
    CompanyDetails = 1,
    PersonalDetails = 2,
    Service = 3,
    Proposal = 4
}

@Component({
    selector: 'mart-detail-merchant',
    templateUrl: './mart-detail-merchant.component.html',
    styleUrls: ['./mart-detail-merchant.component.scss',
        '../../../../../styles/sidebar.scss'],
    providers: [MessageService]
})
export class MartDetailMerchantComponent implements OnInit {
    public merchantId: number = 0;
    @Input()
    set _merchantId(value: number) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.detailMerchant();
        }
    }

    public showMartDetailMerchantSideBar: boolean = false;
    @Input()
    set _showMartDetailMerchantSideBar(value: boolean) {
        this.showMartDetailMerchantSideBar = value;
    }

    @Input() public martMerchantsComponent!: MartMerchantsComponent;

    @Output() changedShowMartDetailMerchantSideBarEmit = new EventEmitter<boolean>();
    changedShowMartDetailMerchantSideBar(increased: any) {
        this.changedShowMartDetailMerchantSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService,
        private nationalityService: NationalityService) { }

    public loading: boolean = false;

    public menuTab = menuTab;
    public activeMenuTab: menuTab = menuTab.CompanyDetails;

    public merchantServiceTypeEnum = MerchantServiceTypeEnum;
    public companyPositions = CompanyPosition.CompanyPositionList;
    public salutations = Salutation.SalutationList;
    public suffixes = Suffix.SuffixList;

    public merchant: any = {};
    public natioanlities: any = {};

    ngOnInit(): void {
        this.getNationalities();
    }

    public getNationalities() {
        this.nationalityService.getIsActiveNationalities(null, this.messageService).then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.natioanlities = data.Items;
        });
    }

    public detailMerchant() {
        this.loading = true;

        const dto = { MerchantId: this.merchantId };

        this.merchantService.detailMerchant(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.merchant = data;
        });
    }

    public nextTab(tab: menuTab) {
        this.activeMenuTab = tab;
    }

    cancel() {
        this.changedShowMartDetailMerchantSideBar(this.showMartDetailMerchantSideBar);
    }
}
